import React from "react";
import { connect } from "react-redux";

import { Redirect, Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import User from "@mapmycustomers/shared/types/User";

import Path from "@app/enum/Path";
import onboardingAnalytics from "@app/scene/dashboard/utils/onboardingAnalytics";
import { getCurrentUser, isOnboardingEnabled } from "@app/store/iam";
import { isMember } from "@app/store/iam/util";
import { RootState } from "@app/store/rootReducer";
import AnalyticsContext from "@app/util/contexts/AnalyticsContext";

import ViewMode from "./enums/ViewMode";
import OnboardingGuides from "./OnboardingGuides";
import OnboardingUsers from "./OnboardingUsers";
import UserOnboardingPage from "./UserOnboardingPage";

interface Props {
  currentUser: undefined | User;
  isOnboardingSupported: boolean;
}

const Onboarding: React.FC<Props> = ({ currentUser, isOnboardingSupported }) => {
  const { path } = useRouteMatch();
  const history = useHistory();

  if (!isOnboardingSupported) {
    history.push(Path.DASHBOARD);
    return null;
  }

  if (!currentUser) {
    return null; // not yet loaded probably
  }

  return (
    <AnalyticsContext.Provider value={onboardingAnalytics}>
      {isMember(currentUser) ? (
        <Switch>
          <Route path={`${path}/${ViewMode.MY}`}>
            <UserOnboardingPage />
          </Route>
          <Route>
            <Redirect to={`${path}/${ViewMode.MY}`} />
          </Route>
        </Switch>
      ) : (
        <Switch>
          <Route path={`${path}/${ViewMode.GUIDES}`}>
            <OnboardingGuides />
          </Route>
          <Route path={`${path}/${ViewMode.USERS}`}>
            <OnboardingUsers />
          </Route>
          <Route path={`${path}/${ViewMode.MY}`}>
            <UserOnboardingPage />
          </Route>
          <Route exact path={path}>
            <Redirect to={`${path}/${ViewMode.GUIDES}`} />
          </Route>
        </Switch>
      )}
    </AnalyticsContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentUser: getCurrentUser(state),
  isOnboardingSupported: isOnboardingEnabled(state),
});

export default connect(mapStateToProps)(Onboarding);
